import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { RHFTextField } from "../../../Shared/RHFTextField";
import { Receipt } from "@mui/icons-material";

const Billing = ({ hfControl }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <Receipt color="primary" />
        <Typography variant="h6" fontWeight={600}>
          Estimated Budget
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        How much do you estimate this project will cost? Leave blank for
        recurring projects where the per-flat amount is set in settlement config.
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <RHFTextField
            fullWidth
            name="estimatedBudget"
            label="Estimated Budget (₹) — optional"
            {...hfControl}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Billing;
